/*
 * CalendarControls Messages
 *
 * This contains all the text for the CalendarControls component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  previousWeek: {
    id: 'app.components.CalendarControls.previousWeek',
    defaultMessage: 'Previous Week',
  },
  nextWeek: {
    id: 'app.components.CalendarControls.nextWeek',
    defaultMessage: 'Next Week',
  },
  previousDay: {
    id: 'app.components.CalendarControls.previousDay',
    defaultMessage: 'Previous Day',
  },
  nextDay: {
    id: 'app.components.CalendarControls.nextDay',
    defaultMessage: 'Next Day',
  },
  cancel: {
    id: 'app.components.CalendarControls.cancel',
    defaultMessage: 'Cancel',
  },
});
